module.exports = __webpack_public_path__ + "static/media/75_tn.e11de342.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/75_tn.jpg
// module id = 560
// module chunks = 0